import commonMixin from '../../mixins/_common';
import modalMixin from './../../mixins/_modal';
import tableEditor from './../../components/_table_editor';

// 在庫データ初期値
const ADD_DEFAULT_VALUE = {
    code: '',
    quantity: 0,
    allow_overdraft: '',
    lead_time_instock: '',
    lead_time_outstock: '',
    pick_and_delivery_code: '',
    image: {
        urls: [],
        main_flag: 0,
    },
    price: '',
};

// 値入力バリデーション定義
const VALUES_VALID_CONFIGS = {
    // 個別コード入力
    ITEM_CODE_INPUT: [
        {
            message: '半角英数字、ハイフン以外は入力できません',
            judgment: (value) => (/^[0-9a-z-]*$/.test(value))
        },
        {
            message: '100文字以上は入力できません',
            judgment: (value) => (value.length < 100)
        },
    ],
};

// 項目名バリデーション定義
const LAYOUT_NAME_VALID_CONFIGS = [
    {
        message: '全角28文字以内で入力してください',
        judgment: (value) => {
            // 全角28文字以内
            const maxWidth = 28 * 2;
            // value が null または undefined の場合、空文字列を設定
            value = value || '';

            let length = 0;
            for (let i=0; i<value.length; i++) {
                if (value[i].match(/[ -~\n]/) ) {
                    length += 1;
                } else {
                    length += 2;
                }
            }
            return (length < maxWidth);
        }
    },
    {
        message: '半角スペース、半角記号の|,<>;:&=#"\\は入力できません',
        judgment: (value) => (!/[ |,<>;:&=#"\\]/.test(value))
    },
];

/**
 * 表在庫編集コンポーネント
 */
export default {
    name: 'tableStockEditor',
    template: '#table_stock_editor_component_template',
    data () {
        return {
            // モーダル内編集中のsubcodes_config
            edit_modal_subcodes_config: {},
            // 表示画面
            step: 1,
        };
    },
    props: {
        // アプリ用subcodesデータ
        subcodes_config: {
            type: Object,
            default: () => ({}),
            required: true
        },
        // 商品コード
        item_code: {
            type: String,
            default: '',
            required: false
        },
        // 編集ページID
        edit_id_dir: {
            type: [String, Number],
            required: false,
            default: null
        },
        // 詳細画像一覧
        lib_images_config: {
            type: Array,
            required: true,
        },
        //「個別商品価格」を設定するフラグ
        variant_price_show: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        // 表設定編集コンポーネント
        'table-editor': tableEditor,
    },
    computed: {
        // 編集連動中のsubcodes_config
        edit_subcodes_config: {
            get() {
                return this.subcodes_config;
            },
            set(value) {
                this.emitUpdateSubcodesConfig(value);
            },
        },
        // 在庫データ初期値
        addDefaultValue: function () {
            return ADD_DEFAULT_VALUE;
        },
        // 項目名バリデーション定義
        layoutNameValidConfig: function () {
            return LAYOUT_NAME_VALID_CONFIGS;
        },
        // 個別コードバリデーション定義
        itemCodeInputValidConfig: function () {
            return VALUES_VALID_CONFIGS.ITEM_CODE_INPUT;
        },
        // 列名の入力フォームを表示(1列目の値が空でない)
        showEditColName: function () {
            return this.edit_modal_subcodes_config.layout.cols.values[0].name.length >= 1;
        },
        // 編集ページか否か
        isEditItem: function () {
            return (this.$_params('item_code') !== null);
        },
        // 税込か否か
        isTaxIncluded: function () {
            // 税設定の取得
            const data = document.querySelector('[data-roll="tax_data"]');
            const taxData = (!!data && !!JSON.parse(data.innerHTML)) ? JSON.parse(data.innerHTML)['data'] : null;
            // 税込の真偽値を返す
            return !taxData || Number(taxData.tax_included);
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
    ],
    emits: ['update:subcodes_config'],
    methods: {
        // パス選択＆カテゴリ編集画面を開く
        show: function () {
            this.edit_modal_subcodes_config = _.cloneDeep(this.subcodes_config);
            this.iniSubcodesConfig();
            this.step = 1;
            this.open();
        },
        // 個別コード編集画面へ
        next: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            this.step++;
        },
        // モーダル編集内容を保存する
        save: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            // 以下カスタムバリデーション(縦横軸のタイトルバリデーション)
            if (!this.layoutNameValidation()) {
                event.target.form.reportValidity();
                return;
            }

            // データ更新
            this.emitUpdateSubcodesConfig(this.edit_modal_subcodes_config);
            this.close();
        },
        // 縦横軸のタイトルバリデーション
        layoutNameValidation: function () {
            const validConfig = this.layoutNameValidConfig[1];
            const layout = this.edit_modal_subcodes_config.layout;
            for (const key in layout) {
                const refKey = 'layout_' + key + '_name';
                const value = layout[key].name;
                if (!validConfig.judgment(value)) {
                    this.$refs[refKey].setCustomValidity(validConfig.message);
                    return false;
                }
            }
            return true;
        },
        // 通常在庫商品を編集した時など表在庫設定は空な為、最低初期値をセットする
        iniSubcodesConfig: function () {
            if (this.edit_modal_subcodes_config.values.length === 0) {
                this.edit_modal_subcodes_config.values = [[_.cloneDeep(this.addDefaultValue)]];
                this.edit_modal_subcodes_config.layout.cols.values = [{name: ''}];
                this.edit_modal_subcodes_config.layout.rows.values = [{name: ''}];
            }
        },

        // -------------------------
        // emit
        // -------------------------

        emitUpdateSubcodesConfig: function (value) {
            this.$emit('update:subcodes_config', value);
        }
    }
};
